<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="seach"
      label-width="250"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'select',
          placeholder: this.$t('HT.deviceType'),
          options: [
            {
              value: '0',
              label: 'GT12'
            },
            {
              value: '1',
              label: 'GT300G'
            }
          ],
          key: 'type',
          event: 'change'
        },
        {
          type: 'select',
          placeholder: this.$t('HT.fileType'),
          options: [
            {
              value: 'dump',
              label: 'dump'
            },
            {
              value: 'gate',
              label: 'gate'
            }
          ],
          key: 'application',
          event: 'change'
        },
        {
          type: 'select',
          placeholder: this.$t('HT.upgrade.appType'),
          options: [
            {
              value: '1',
              label: this.$t('HT.upgradeFiles.appType1')
            },
            {
              value: '0',
              label: this.$t('HT.upgradeFiles.appType2')
            }
          ],
          key: 'application',
          event: 'change'
        },
        {
          type: 'input',
          key: 'version',
          hideBtn: true,
          placeholder: this.$t('HT.upgradeFiles.version')
        },
        {
          type: 'input',
          key: 'imei',
          hideBtn: true,
          placeholder: this.$t('HT.upgradeFiles.imei')
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.upgradeFiles.imei'),
          tooltip: true,
          // align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    console.log(params);
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.deviceType'),
          prop: 'logger_host',
          tooltip: true
        },
        {
          label: this.$t('HT.fileType'),
          prop: 'message',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeFiles.version'),
          prop: 'message',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeFiles.message'),
          prop: 'message',
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.appType'),
          prop: 'message',
          tooltip: true
        },
        {
          label: this.$t('HT.upgradeFiles.remark'),
          prop: 'message',
          tooltip: true
        },
        {
          label: this.$t('HT.uptime'),
          prop: 'message',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数  这里还缺少搜索所需的参数
        page: 1,
        size: 10
      },
      apiList: [], // api 列表
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getLogList(params) {
      this.$api.log.getLogList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    // getApiList() {
    //     this.$api.log.getLogList().then(res => {
    //         if (res.code == 10000) {
    //             this.apiList = this.layout[1]['option'] = res.data;
    //         }
    //     });
    // },

    /**
     * 搜索
     */
    seach() {
      if (this.filter.type == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning(this.$t('HT.upgradeFiles.type.placeholder'));
        return;
      }
      if (this.filter.application == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning(this.$t('HT.upgradeFiles.application.placeholder'));
        return;
      }
      if (this.filter.imei == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning(this.$t('HT.upgradeFiles.imei.placeholder'));
        return;
      } else {
        this.getLogList(this.filter);
        this.filter.page = 1;
      }
    },

    change() {
      this.filter.page = 1;
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getLogList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getLogList(this.filter);
    }
  }
};
</script>
